// Import schema statically to avoid issues
// This pattern works in both Vite and webpack
import schemaData from './gql/introspection-result.json';

export * from './gql';
export * from './gql/graphql';
export * from './lib';
export * from './lib/health-check';
export * from './temp-types';

export const gqlSchema = schemaData;
